/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormulaPropagationHpListDialogConfig } from '@gh/builder-shared';
import { HousePlanRestService } from '@gh/builder-shared-data';
import { getDialogInitData } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { DialogInput, WaitingService } from '@gh/core-ui';
import { GridRowEvent } from '@gh/core-ui-grid';
import { assign, find, isEmpty, isNil, pull } from 'lodash';
import { ComponentPropagateFormulaModelItemCustom, HousePlanListItem } from '../../resources/house-plans.model';
import { FormulaPropagationHpGridDefinition } from './formula-propagation-hp-grid.service';

@Component({
  selector: 'gh-formula-propagation-hp-list-dialog',
  template: require('./formula-propagation-hp-list-dialog.component.html'),
  styles: [require('./formula-propagation-hp-list-dialog.component.scss')],
  providers: [FormulaPropagationHpGridDefinition],
})
export class FormulaPropagationHpListDialogComponent implements OnInit,
                                                                DialogInput<FormulaPropagationHpListDialogConfig> {
  input: FormulaPropagationHpListDialogConfig;

  dataSource: SlicedDataSource<HousePlanListItem>;

  formula: string;
  code: string;
  private selected: ComponentPropagateFormulaModelItemCustom[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              public gridDefinition: FormulaPropagationHpGridDefinition,
              private waitingService: WaitingService,
              private dialogRef: MatDialogRef<any>,
              private businessService: HousePlanRestService) {

  }

  get elementNameLabel(): string {
    return this.input.isComponent ? 'lbl_component' : 'lbl_item';
  }

  get hasSelected(): boolean {
    return !isEmpty(this.selected);
  }

  ngOnInit(): void {
    assign(this, getDialogInitData(this.dialogData));
    this.formula = this.input && this.input.formula;
    this.code = this.input && this.input.elementCode;

    this.loadData();
  }

  onRowClicked(event: GridRowEvent<ComponentPropagateFormulaModelItemCustom>): void {
    this.toggle(event.data);
  }

  onToggle(row: ComponentPropagateFormulaModelItemCustom): void {
    this.toggle(row);
  }

  onApply(): void {
    this.dialogRef.close(this.selected);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  isSelected(row?: ComponentPropagateFormulaModelItemCustom): boolean {
    if (row) {
      return !isNil(find(this.selected, { code: row.code }));
    } else {
      return false;
    }
  }

  private loadData(): void {
    const { elementId, isComponent, costCenterId, oldFormula, excludeIds } = this.input;
    const filter = {
      salesEstimate: false,
      quickQuote: false,
      showDeleted: false,
      excludeIds,
      filterParameter: {
        propagateFormulaFilter: isComponent ? {
          oldFormula,
          isComponent: true,
          itemId: elementId,
          costCenterId,
        } : {
          oldFormula,
          isComponent: false,
          itemId: elementId,
          costCenterId,
        },
      },
    };

    this.dataSource = this.businessService.findAllAsDataSource(filter);
  }

  private toggle(row: ComponentPropagateFormulaModelItemCustom): void {
    if (this.isSelected(row)) {
      this.unselect(row);
    } else {
      this.select(row);
    }
  }

  private select(row: ComponentPropagateFormulaModelItemCustom): void {
    this.selected.push(row);
  }

  private unselect(row: ComponentPropagateFormulaModelItemCustom): void {
    pull(this.selected, row);
  }
}
